import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Button } from '@mui/material';

function NavBar({ items, className }) {
  const [activeTab, setActiveTab] = useState(items[0].name);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Update active tab based on current route
    const currentPath = location.pathname;
    const currentItem = items.find(item => item.url === currentPath);
    if (currentItem) {
      setActiveTab(currentItem.name);
    }
  }, [location.pathname, items]);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          background: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(10px)',
          padding: '4px',
          borderRadius: 100,
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
          border: '1px solid rgba(0, 0, 0, 0.05)',
        }}
      >
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.name;

          return (
            <Button
              key={item.name}
              onClick={() => {
                setActiveTab(item.name);
                navigate(item.url);
              }}
              sx={{
                position: 'relative',
                minWidth: isMobile ? '48px' : '120px',
                py: 1,
                px: 3,
                color: isActive ? '#E65A2F' : 'rgba(0, 0, 0, 0.6)',
                '&:hover': {
                  bgcolor: 'rgba(230, 90, 47, 0.05)',
                },
                borderRadius: '100px',
              }}
            >
              <span style={{ display: isMobile ? 'none' : 'inline' }}>{item.name}</span>
              <span style={{ display: isMobile ? 'inline' : 'none' }}>
                <Icon size={18} />
              </span>
              {isActive && (
                <motion.div
                  layoutId="bubble"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: '100px',
                    backgroundColor: 'rgba(230, 90, 47, 0.1)',
                  }}
                  transition={{
                    type: "spring",
                    bounce: 0.2,
                    duration: 0.6,
                  }}
                />
              )}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
}

export default NavBar; 